import React from 'react';
import { Card } from './ui/card';
import { Calendar, Clock, Award } from 'lucide-react';

export const Timeline = () => {
  const milestones = [
    {
      label: 'ENTRY DEADLINE',
      date: 'June 10, 2026',
      icon: Calendar,
      note: 'Projects must be completed by December 31, 2025'
    },
    {
      label: 'Jury Review',
      date: 'Aug 10, 2026',
      icon: Clock
    },
    {
      label: 'Winners Announced',
      date: 'Oct 10, 2026',
      icon: Award
    }
  ];

  return (
    <section
      id="timeline"
      className="bg-[#FEF3C7] py-16 sm:py-20"
      data-testid="timeline-section"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-amber-800 tracking-wider uppercase mb-2">
            Important Dates
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Competition Timeline
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {milestones.map((milestone, index) => (
            <Card
              key={index}
              className="relative p-6 rounded-xl bg-white border-2 border-amber-200 hover:border-amber-400 transition-colors duration-200 shadow-sm hover:shadow-md"
              data-testid={`timeline-card-${index}`}
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
                  <milestone.icon className="h-6 w-6 text-amber-600" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-bold text-amber-700 tracking-wider uppercase mb-1">
                    {milestone.label}
                  </div>
                  <div className="text-2xl font-bold text-gray-900 mb-2">
                    {milestone.date}
                  </div>
                  {milestone.note && (
                    <div className="text-sm text-gray-600 flex items-start gap-1.5">
                      <span className="text-amber-600 mt-0.5">⚠</span>
                      <span>{milestone.note}</span>
                    </div>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-700">
            Entry deadline: June 10, 2026 • Winners announced: October 10, 2026
          </p>
        </div>
      </div>
    </section>
  );
};